import { Component, HostListener, OnInit, NgZone } from '@angular/core'; // 1. Importe NgZone
import { LoadingService } from "./services/loading.service";
import { delay } from "rxjs";
import { AuthTokenService } from './services/auth-token.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'medicos-module';
  loading: boolean = false;
  isMaximized: boolean = false;
  unreadCount: number = 0;

  constructor(
    public loadingService: LoadingService, 
    private authTokenService: AuthTokenService, 
    private sanitizer: DomSanitizer,
    private zone: NgZone // 2. Injete o NgZone aqui
  ) {}

  ngOnInit() {
    this.loadingService.isLoading.pipe(delay(0)).subscribe(isLoading => {
      this.loading = isLoading;
    });
  }

  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent) {
    if (event.data && event.data.type === 'CHAT_UNREAD_UPDATE') {
      
      // 3. USE O ZONE.RUN: Isso força a tela a atualizar imediatamente
      this.zone.run(() => {
        this.unreadCount = event.data.count || 0;
        console.log('Angular atualizou unreadCount para:', this.unreadCount);
      });
    }
  }

  get isUserLoggedIn(): boolean {
    return !!this.authTokenService.medicoId;
  }

  get chatUrl(): SafeResourceUrl | null {
    const medicoData = this.authTokenService.medicoId;
    if (medicoData && medicoData.num_Conselho) {
      const idParaChat = medicoData.num_Conselho;
      const baseUrl = 'https://clinica-recepcao.fgr.org.br/medico/chat'
      const fullUrl = `${baseUrl}?id=${encodeURIComponent(idParaChat)}`;
      return this.sanitizer.bypassSecurityTrustResourceUrl(fullUrl);
    }
    return null;
  }

  toggleChat(): void {
    this.isMaximized = !this.isMaximized;
  }
}